/**
 * The locales a user can choose, with their names written in themselves.
 *
 * Endonyms, not translations. A picker that lists "Arabic" in English is useless
 * to the person who needs it most: someone who has landed in the wrong language
 * and is looking for their own. `العربية` is findable by anyone who reads it,
 * whatever the surrounding UI happens to say.
 */
export interface LocaleOption {
  /** BCP-47 tag, matching a catalogue key. */
  tag: string;
  /** The language's name in that language. */
  endonym: string;
}

export const LOCALE_OPTIONS: readonly LocaleOption[] = [
  { tag: 'en', endonym: 'English' },
  { tag: 'he', endonym: 'עברית' },
  { tag: 'ar', endonym: 'العربية' },
  { tag: 'es', endonym: 'Español' },
  { tag: 'pt-BR', endonym: 'Português (Brasil)' },
  { tag: 'hi', endonym: 'हिन्दी' },
  { tag: 'ja', endonym: '日本語' },
];
